var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaArrowUp } from 'react-icons/fa';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
import depositAssets from '../helpers/depositAssets.json';
export var SupplyTo = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'ACTION',
    method: 'supplyTo',
    description: "Transfers an asset to the Compound protocol and adds it to the account's balance",
    supportedContracts: cometList,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    destination: new FctAddress({ isPreview: true, icon: FaArrowUp }),
                    asset: new FctAddress({
                        destination: 'erc20',
                        options: depositAssets
                            .filter(function (token) { return token.chainId === Number(chainId); })
                            .map(function (asset) { return (__assign(__assign({}, asset), { value: asset.address })); }),
                        isPreview: true,
                        icon: FaArrowUp
                    }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                },
            },
            output: {},
        });
    },
    requiredApprovals: function (params) {
        var _a = params.methodParams, asset = _a.asset, amount = _a.amount;
        return [
            {
                to: asset.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: amount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, _a = params.methodParams, asset = _a.asset, amount = _a.amount, destination = _a.destination;
        if (!amount.value || !asset.value || !to.value || !destination.value || !vaultAddress)
            return [];
        if (typeof amount.value !== 'string' ||
            typeof asset.value !== 'string' ||
            typeof to.value !== 'string' ||
            typeof destination.value !== 'string')
            return [];
        var flow = [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
                toReceive: [],
            },
            {
                address: to.value,
                toSpend: [],
                toReceive: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
            },
        ];
        if (destination.value.toLowerCase() === vaultAddress.toLowerCase()) {
            flow[0].toReceive = [
                {
                    token: asset.value,
                    amount: amount.value,
                },
            ];
        }
        else {
            flow.push({
                address: destination.value,
                toSpend: [],
                toReceive: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
            });
        }
        return flow;
    },
});
